import { ErrorModal } from "components/ui/ErrorModal";
import { useGlobalErrorContext } from "context/globalErrorContext";

export const GlobalErrorModal: FC = () => {
  const {
    actions: { closeErrorModal, retryAction },
    state: { error, modalOpen },
  } = useGlobalErrorContext();

  return (
    <ErrorModal data-testid="global-error-modal" error={error} isOpen={modalOpen} onClose={closeErrorModal} onRetry={retryAction} shouldCloseOnRetry />
  );
};
